export const PERIOD_UNIT_BILLING_PERIOD = 'billing period';
export const PERIOD_UNIT_SECONDS = 's';
export const PERIOD_UNIT_MINUTES = 'min';
export const PERIOD_UNIT_HOURS = 'hour(s)';
export const PERIOD_UNIT_DAYS = 'day(s)';
export const PERIOD_UNIT_CALENDAR_DAYS = 'calendar day(s)'; // until midnight
export const PERIOD_UNIT_WEEKS = 'week(s)';
export const PERIOD_UNIT_MONTHS = 'month(s)';
export const PERIOD_UNIT_YEARS = 'year(s)';

const EVERY_MASCULINE = ['každý', 'každé', 'každých'];
const EVERY_FEMININE = ['každá', 'každé', 'každých'];

/**
 * @property {number} amount
 * @property {string} unit - unit string from exported constants
 */
export class Period {
  /**
   * @param {number} amount
   * @param {string} unit - unit string from exported constants
   */
  constructor({ amount, unit }) {
    this.amount = amount;
    this.unit = unit;
  }

  /**
   * Returns string representation of period used for service price display.
   *
   * @param {boolean} isRepeating
   * @returns {string}
   */
  getLabel(isRepeating) {
    switch (this.unit) {
      case PERIOD_UNIT_SECONDS:
        return this._getConjugatedLabel(isRepeating, EVERY_FEMININE, [
          'sekunda',
          'sekundy',
          'sekúnd',
        ]);
      case PERIOD_UNIT_MINUTES:
        return this._getConjugatedLabel(isRepeating, EVERY_FEMININE, ['minúta', 'minúty', 'minút']);
      case PERIOD_UNIT_HOURS:
        return this._getConjugatedLabel(isRepeating, EVERY_FEMININE, ['hodina', 'hodiny', 'hodín']);
      case PERIOD_UNIT_DAYS:
        return this._getConjugatedLabel(isRepeating, EVERY_MASCULINE, ['deň', 'dni', 'dní']);
      case PERIOD_UNIT_WEEKS:
        return this._getConjugatedLabel(isRepeating, EVERY_MASCULINE, [
          'týždeň',
          'týždne',
          'týždňov',
        ]);
      case PERIOD_UNIT_MONTHS:
        return this._getConjugatedLabel(isRepeating, EVERY_MASCULINE, ['mes.', 'mes.', 'mes.']);
      case PERIOD_UNIT_YEARS:
        return this._getConjugatedLabel(isRepeating, EVERY_MASCULINE, ['rok', 'roky', 'rokov']);
      case PERIOD_UNIT_CALENDAR_DAYS:
        return this._calendarDayLabel;
      default:
        throw new Error(`Unhandled period "${this.unit}"`);
    }
  }

  /**
   * @param {string} isRepeating
   * @param {string} everySingle
   * @param {string} everySmallCount
   * @param {string} everyLargeCount
   * @param {string} unitSingle
   * @param {string} unitSmallCount
   * @param {string} unitLargeCount
   * @return {string}
   * @private
   */
  _getConjugatedLabel(
    isRepeating,
    [everySingle, everySmallCount, everyLargeCount],
    [unitSingle, unitSmallCount, unitLargeCount],
  ) {
    if (this.amount === 1) {
      return `${isRepeating ? `${everySingle} ` : ''}${unitSingle}`;
    }

    if (this.amount >= 2 && this.amount <= 4) {
      return `${isRepeating ? `${everySmallCount} ` : ''}${this.amount} ${unitSmallCount}`;
    }

    return `${isRepeating ? `${everyLargeCount} ` : ''}${this.amount} ${unitLargeCount}`;
  }

  /**
   * @returns {string}
   * @private
   */
  get _calendarDayLabel() {
    if (this.amount !== 1) {
      throw new Error(`Unhandled amount "${this.amount}" for calendar day period`);
    }

    return 'dnes';
  }
}
